/**
 * What an `email_domains` row stands for.
 *
 * A missing `identityType` means DOMAIN (every row created before address
 * identities existed). An ADDRESS row stores the FULL address in `domain`
 * (`max@firma.de` — the SES identity string) and the mandatory local part in
 * `localPart`; its ownership proof is a mailed one-time code instead of a DNS
 * TXT token.
 */
export enum EmailIdentityType {
  DOMAIN = "DOMAIN",
  ADDRESS = "ADDRESS",
}
